// Import Packages
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'

// Import Material UI
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { CircularProgress } from '@material-ui/core';

// Import Pages
import LeftArea from './leftArea/LeftArea';
import MiddleArea from './middleArea/MiddleArea';
import RightArea from './../../../../components/FlowConfigurationForms';
import TestAppLog from './middleArea/TestAppLog/testAppLog';
import WaitingQueueModal from '../autom/component/WaitingQueueModal';
import RunningModal from '../autom/component/RunningModal';
import ExportConfirm from '../../../../components/Export/ExportConfirm';
import ImportModal from '../../../../components/Import/ImportModal';
import SlowMotionModal from '../../../../components/SlowMotion/SlowMotionModal';
import Publish from '../publish/Publish';
import EditAutomName from '../autom/editAction/editAutomName/EditAutomName';
import DesktopActions from '../../../../components/FlowConfigurationForms/DesktopRecorder/Scope/DesktopActions/DesktopActions';
import Schedule from '../Schedule/Schedule';
import TriggerModal from '../autom/header/TriggerModal';
import MateDrive from '../../../../components/MateDrive/MateDrive';
import Debugger from '../autom/debugger';
import Roi from "../roi/Roi";
import {
    activeAutom,
    activeItemsAtom,
    activeTab,
    alertState,
    defaultItems,
    defaultTriggerItem,
    defaultTriggerDetail,
    debugList,
    licensePermission,
    triggerConf,
    fieldPreviewData,
    triggerSelection, testAppLog, browserTabId, openDesktopRecordAtom,
    openDebugRunning, saveAvailable, initialActions, changedFields, itemExpand, copiedItemState, baseOrigin, errorHandlingActiveAutom, errorHandlingAutom
} from '../../../../recoil-store/recoil-state';
import { useRecoilActions } from '../../../../recoil-store/recoil-actions';
import { handleInit, handleUpdate } from '../../../../helpers/flowHistory';
import DeleteConfirm from "../../../../components/DataTable/DeleteConfirm";
import AppCredentialModal from "../../appCredential/appCredentialModal/AppCredentialModal";
import Info from '../autom/editAction/components/Info';

// Import Services
import VariableService from '../../../../services/VariableService/VariableService';
import AutomService from '../../../../services/AutomService/AutomService';
import triggerService from '../../../../services/triggerService/triggerService';
import QueueService from '../../../../services/QueueService/QueueService';
import automService from "../../../../services/AutomService/AutomService";
import BotService from '../../../../services/BotService/BotService';
import ApplicationService from '../../../../services/ApplicationService/ApplicationService';

// Import Helpers
import { changeOrder, handleDebugArray, valueController, findParentLibraryGroup } from '../../../../helpers/helper';
import * as helper from "../../../../helpers/helper";

// Import Css
import './NewFlow.css';

// Import Icons
import actionControlIcon from '../../../../assets/icons/action-control-icon.svg';
import maximizeIcon from '../../../../assets/icons/maximize-icon.svg';
import { set } from 'date-fns';
import TabDialog from './middleArea/detailTabs/TabDialog';
import AddNewAutom from '../addNewAutoms/AddNewAutom';
import RoiIcon from '../../../../assets/icons/roi-icon.svg'
import DiagramIcon from '../../../../assets/icons/diagram-icon.svg'
import CollapseLeftAreaIcon from '../../../../assets/icons/collapse-left-area-icon.svg'
import ExpandLeftAreaIcon from '../../../../assets/icons/expand-left-area-icon.svg'
import DataStoreIcon from '../../../../assets/icons/headerIcons/data-store-icon.svg';
import FavoriteActions from '../../../../assets/icons/favorite-actions-icon.svg';
import MSTeamsIcon from '../../../../assets/icons/shortCutIcons/msteams-icon.svg'
import WhatsappIcon from '../../../../assets/icons/shortCutIcons/whatsapp-icon.svg'
import LibraryService from '../../../../services/LibraryService/LibraryService';
import RequiredLibraries from '../../market/cards/requiredLibraries/RequiredLibraries';

const gmailAppId = "e36d6014-0389-4cb1-b781-a9686f44f9d3";

const NewFlow = (props) => {
    let params = useParams();
    const history = useNavigate()

    const paramsId = params.id;
    const license = useRecoilValue(licensePermission);
    const tab_id = useRecoilValue(browserTabId);
    const [testAppLogs, setTestAppLogs] = useRecoilState(testAppLog);
    const [expand, setExpand] = useRecoilState(itemExpand);
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [errorHandlingAutomDetails, setErrorHandlingAutomDetails] = useRecoilState(errorHandlingAutom);
    const [selectedEhAutomDetail, setSelectedEhAutomDetail] = useRecoilState(errorHandlingActiveAutom);
    const [isEhFlow, setIsEhFLow] = useState(false);
    const [activeItems, setActiveItems] = useRecoilState(activeItemsAtom);
    const [triggerDetail, setTriggerDetail] = useRecoilState(defaultTriggerDetail);
    const [savedFlow, setSavedFlow] = useState([]);
    const recoilActions = useRecoilActions();
    const { t } = useTranslation();
    const [openVariable, setOpenVariable] = useState({ type: "", id: "" });
    const [showRightArea, setShowRightArea] = useState(false);
    const [openResetTrigger, setOpenResetTrigger] = useState(false);
    const [openResetFlow, setOpenResetFlow] = useState(false);
    const [showTriggerRightArea, setShowTriggerRightArea] = useState(false);
    const recorder = useRef([]);
    const drecorder = useRef([]);
    const [groupLabel, setGroupLabel] = useState("");
    const [dialog, setDialog] = useState(null);
    const [loader, setLoader] = useState(true);
    const [tabFilter, setTabFilter] = useRecoilState(activeTab);
    const [detailTabs, setDetailTabs] = useState([]);
    const [showLeftArea, setShowLeftArea] = useState(true);
    const [variables, setVariables] = useState([]);
    const [actions, setActions] = useState({});
    const [automVersion, setAutomVersion] = useState('');
    const [operationId, setOperationId] = useState("");
    const [openWaitingQueueModal, setOpenWaitingQueueModal] = useState(false);
    const [differentLibraryVersions, setDifferentLibraryVersions] = useState(false);
    const [tempImportFile, setTempImportFile] = useState(undefined);
    const [numberQueue, setNumberQueue] = useState(0);
    const [openRunningModal, setOpenRunningModal] = useState(false);
    const [openSaveModal, setOpenSaveModal] = useState(false);
    //const [openDebugRunning, setOpenDebugRunning] = useState(false);
    const [debuggingStart, setDebuggingStart] = useState(false);
    const [devMode, setDevMode] = useState(false);
    const [debuggingDelay, setDebuggingDelay] = useState(1000);
    const [flowStatus, setFlowStatus] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [openPublish, setOpenPublish] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [reCheck, setReCheck] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [triggerModal, setTriggerModal] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [triggerType, setTriggerType] = useState('');
    const [openSchedule, setOpenSchedule] = useState(false);
    const [openDrive, setOpenDrive] = useState(false);
    const [openExport, setOpenExport] = useState(false);
    const [openImport, setOpenImport] = useState(false);
    const [openSlowMotion, setOpenSlowMotion] = useState(false);
    const openDesktopRecord = useRecoilValue(openDesktopRecordAtom);
    const [debuggingExpand, setDebuggingExpand] = useState(false);
    const [publishFlowData, setPublishFlowData] = useState([]);
    const [openRoi, setOpenRoi] = useState(false);
    const [diagramData, setIsDiagramData] = useState([]);
    const [exportData, setExportData] = useState({});
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [debugErrorMessage, setDebugErrorMessage] = useState();
    const setTriggerConf = useSetRecoilState(triggerConf);
    const setTriggerSelection = useSetRecoilState(triggerSelection);
    const setFieldPreviewData = useSetRecoilState(fieldPreviewData);
    const setOpenDebugRunning = useSetRecoilState(openDebugRunning);
    const [triggerSelectionData, setTriggerSelectionData] = useRecoilState(triggerSelection);
    const [loading, setLoading] = useState(true);
    const [debugActionItemId, setDebugActionItemId] = useState('');
    const [openTestAppLog, setOpenTestAppLog] = useState(false);
    const [testAppStarted, setTestAppStarted] = useState(false);
    const [gmailApp, setGmailApp] = useState();
    const [gmailCredentialId, setGmailCredentialId] = useState('');
    const [credentialQuestion, setCredentialQuestion] = useState(false);
    const [openAppCredential, setOpenAppCredential] = useState(false);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setInitialActions = useSetRecoilState(initialActions);
    const setChangeFields = useSetRecoilState(changedFields);
    const setItemExpand = useSetRecoilState(itemExpand);
    const [openImportInfo, setOpenImportInfo] = useState({ open: false });
    const [isMSTeamsExist, setIsMSTeamsExist] = useState(false);
    const [isWhatsappExist, setIsWhatsappExist] = useState(false);
    const base_origin = useRecoilValue(baseOrigin);

    // const [copiedItem, setCopiedItem] = useRecoilState(copiedItemState)
    // const [baseOrigin, setBaseOrigin] = useState("");

    const [isDiagramBuilder, setIsDiagramBuilder] = useState(
        !(
            localStorage.getItem("tabs") !== null &&
            localStorage.getItem("tabs") !== undefined &&
            localStorage.getItem("tabs") === "diagram"
        )
    );

    const setAlert = useSetRecoilState(alertState);
    const setClearDebugs = useSetRecoilState(debugList);


    const setGmailApplication = async () => {
        const response = await ApplicationService.getApplications({ id: gmailAppId });
        if (response && response.status && response.data.length) {
            setGmailApp(response.data[0]);
        }
    }


    useEffect(() => {
        if (!openTestAppLog) {
            setTestAppLogs({});
        }
    }, [openTestAppLog]);
    useEffect(() => {
        // getBaseOrigin()
        setTabFilter(0)
        setGmailApplication();
    }, []);
    useEffect(() => {
        setDebugActionItemId("")
    }, [debuggingStart]);

    useEffect(() => {
        if (devMode) {
            const versionElements = document.querySelectorAll(".action-version-label")
            versionElements.forEach(element => {
                element.style.display = 'inline';
            });
        }
        else {
            const versionElements = document.querySelectorAll(".action-version-label")
            versionElements.forEach(element => {
                element.style.display = 'none';
            });
        }
    }, [devMode, automDetail.items, isEhFlow, errorHandlingAutomDetails]);

    const cancel = () => {
        setOpenAppCredential(false)
    }

    const afterSave = (t) => {
        setOpenAppCredential(false);
        setGmailCredentialId('');
    }

    // const getBaseOrigin = async () => {
    //     const baseOr = await BASE_ORIGIN;
    //     setBaseOrigin(baseOr)
    // }
    const resesFlowPopUp = () => {
        setOpenResetFlow(true)
    }

    const resetFlow = useCallback(async () => {
        if (debuggingStart) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTOMS.OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'),
                severity: 'error'
            }))
        }
        if (!isEhFlow) {
            setActions({})
            setInitialActions({});
            setChangeFields({});
            setSaveAvailable(true);
            if (automDetail.is_installed) {
                const result = await BotService.getInitialFlow(automDetail.versionId);
                if (result.code === 200) {
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t('MESSAGES.AUTOMS.RESET-FOR-DOWNLOADED-BOT'),
                        severity: 'info'
                    }))
                    // setAutomDetail({
                    //     ...automDetail,
                    //     items: result.data,
                    //     activeItem: []
                    // })
                    setAutomDetail({
                        ...automDetail,
                        items: result.data
                    })
                    setActiveItems([])
                    setTabFilter(0)
                    return
                }
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: result ? result.message : t('GENERAL.NETWORK-ERROR'),
                    severity: 'error'
                }))
            }
            let dItem = JSON.parse(JSON.stringify(defaultItems));
            if (automDetail.type === 'Autom') {
                // trigger unshift in default automDetail
                dItem.unshift(JSON.parse(JSON.stringify(defaultTriggerItem)));
            }
            handleUpdate(undefined, true, dItem)
            // setAutomDetail({
            //     ...automDetail,
            //     items: dItem,
            //     activeItem: []
            // })
            setAutomDetail({
                ...automDetail,
                items: dItem
            })
            setActiveItems([])
            setShowRightArea(false)
            setIsWhatsappExist(false);
            setIsMSTeamsExist(false);
            setTabFilter(0)
            setDetailTabs([])
        } else {
            setSaveAvailable(true);

            let dItem = JSON.parse(JSON.stringify(defaultItems));

            handleUpdate(undefined, true, dItem, "errorHistory", selectedEhAutomDetail.errorHandlingId)

            setSelectedEhAutomDetail((pre) => {
                return {
                    ...pre,
                    items: dItem
                }
            })
            setActiveItems([])
            setShowRightArea(false)
            setIsWhatsappExist(false);
            setIsMSTeamsExist(false);

        }

    }, [automDetail?.versionId, automDetail?.is_installed, defaultItems, defaultTriggerItem, debuggingStart, isEhFlow, selectedEhAutomDetail])

    const handleExport = useCallback(async (e) => {
        if (automDetail.items.length > 2) {
            setOpenSaveModal(true)
            let payloadData = await preparePayloadData("save");
            const response = await AutomService.exportFlow(
                payloadData
            );
            setOpenSaveModal(false)
            if (response.status) {
                setOpenExport(true);
                setExportData({
                    flow: response.data.flow,
                    variables: response.data.variables,
                    fileName: automDetail.name
                });
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(response.message),
                    severity: 'error'
                }))
            }
        }
    }, [automDetail, actions, operationId, automVersion, paramsId, diagramData])

    const handleImport = useCallback((e) => {
        setOpenImport(true);
    }, [])

    const handleSlowMotion = useCallback((e) => {
        setOpenSlowMotion(true);
    }, [])

    const handleResetMSTeamsSession = useCallback(async (e) => {
        const payload = {
            automId: automDetail.id,
            automVersionId: automDetail.versionId,
            libraryName: "MICROSOFT-TEAMS",
            actionName: "RESET",
            action_name: "RESET",
            action_label: "RESET",
            name: "RESET"
        }

        let response = await AutomService.runAction(payload);

        if (response) {
            if (response.status) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.MSTEAMS.SESSION-RESET-SUCCESS"),
                    severity: response.status ? 'success' : 'error'
                }))
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.MSTEAMS.SESSION-RESET-FAILED"),
                    severity: 'error'
                }))
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }))
        }
    }, [automDetail, AutomService])

    const handleDragEnd = useCallback((e, item, isMove, copy) => {
        const conditionHover = document.getElementsByClassName("new-flow-drag-hover-condition");
        Array.prototype.forEach.call(conditionHover, function (el) {
            // Do stuff here
            el.classList.remove('active');
        });

        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            // Do stuff here
            el.classList.remove('active');
        });

        //setSaveAvailable(true);
    }, [])

    const showHorizontalDroppableAreas = (it, me) => {
        const conditionHover = document.getElementsByClassName("new-flow-drag-hover-condition");
        Array.prototype.forEach.call(conditionHover, function (el) {
            // Do stuff here
            Array.prototype.forEach.call(me, function (search) {
                if (it === 'else') {
                    checkAndShowNextConditionArea(el, search);
                } else {
                    showNextConditionArea(el, search);
                }

            })
        });

        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            // Do stuff here
            Array.prototype.forEach.call(me, function (search) {
                if (it === 'else') {
                    checkAndShowNextConditionArea(el, search);
                } else {
                    showNextConditionArea(el, search);
                }
            })
        });
    }

    const showNextConditionArea = (el, search) => {
        if (el.classList.contains(search)) {
            el.classList.add('active');
        }
    }

    const checkAndShowNextConditionArea = (el, search) => {
        const cId = el.getAttribute('condgroupid');
        if (search === "elseif") {
            const isElseExist = document.getElementsByClassName("else-" + cId)
            if (isElseExist.length === 0) {
                if (el.classList.contains(search)) {
                    el.classList.add('active');
                }
            }
        } else {
            const isElseExist = document.getElementsByClassName("else-" + cId)
            const isElseIfExist = document.getElementsByClassName("elseif-" + cId)
            if (isElseExist.length === 0 && isElseIfExist.length === 0) {
                if (el.classList.contains(search)) {
                    el.classList.add('active');
                }
            }
        }
    }

    const handleDragStart = useCallback((e, copyItem, isMove, copy) => {

        // >>>>> DON'T DELETE BELOW COMMENTED LINES
        // let img = document.createElement('img');
        // let canvas = document.createElement('canvas');
        // let ctx = canvas.getContext('2d');
        // img.src = libraryIconsDrag[item.library_name.replace(/-/g, "_").toLowerCase()];
        // img.style.height = '10px';
        // img.style.width = '10px';
        // canvas.height = 30;
        // canvas.width = 30;
        // canvas.backgroundColor = "#F4BB66";
        // ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // e.dataTransfer.setDragImage(img, 0, 0);
        let copyActions
        setActions((pre) => {
            copyActions = JSON.parse(JSON.stringify(pre))
            return pre
        })
        let item = JSON.parse(JSON.stringify(copyItem))
        if (item.library_label === "DESKTOPACTIONS" && copy) {
            return setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.RULE.DESKTOP-ACTIONS-CANNOT-BE-COPY'), severity: 'error' }));
        }
        if (item.children && item.children.length && copy) {
            const childDesktopAction = helper.findChildDesktopActionById(item.children)
            if (childDesktopAction?.actionName) {
                return setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.RULE.GROUPABLE-ACTIONS-CANNOT-BE-COPY-WHILE-HAS-CHILD-DESKTOP-ACTIONS'), severity: 'error' }));
            }
        }
        if (actions[item.id] && item.actionName !== "STOP") {
            item.fields = JSON.parse(JSON.stringify(actions[item.id].fields))
            if (actions[item.id].inputs) {
                item.inputs = JSON.parse(JSON.stringify(actions[item.id].inputs))
            }
        }
        else if (copyActions && copyActions[item.id] && item.actionName !== "STOP") {
            item.fields = JSON.parse(JSON.stringify(copyActions[item.id].fields))
            if (copyActions[item.id].inputs) {
                item.inputs = JSON.parse(JSON.stringify(copyActions[item.id].inputs))
            }
        }
        // else if (item.actionName !== "STOP" && copy)
        if (copy && item.children && item.children.length > 0) {
            helper.updateFlowItems(item.children, copyActions, copyActions)
        }
        if (!isMove || !item.item_id) {
            item.item_id = uuidv4();
        }
        // if (isMove && actions[automDetail.activeItem[0]?.id] && actions[automDetail.activeItem[0]?.id].inputs) {
        //     item.inputs = actions[automDetail.activeItem[0]?.id].inputs
        // }
        if (isMove && actions[activeItems[0]?.id] && actions[activeItems[0]?.id].inputs) {
            item.inputs = JSON.parse(JSON.stringify(actions[activeItems[0]?.id].inputs))
        }
        if (item.action_name === "ELSE") {
            showHorizontalDroppableAreas("else", ["if", "elseif"])
        }

        if (item.action_name === "ELSEIF") {
            showHorizontalDroppableAreas("elseif", ["if", "elseif"])
        }

        if (item.action_name === "LIST-ITEM") {
            showHorizontalDroppableAreas("listitem", ["list-item"])
        }

        if (item.action_name === "BUTTON-ITEM") {
            showHorizontalDroppableAreas("buttonitem", ["button-item"])
        }

        if (e?.stopPropagation) e.stopPropagation();
        if (!isMove || item.action_name !== "IF")
            if (e?.stopPropagation)
                e.stopPropagation();
        if (copy) {
            localStorage.setItem("copiedItem", JSON.stringify({ item, isMove, base_origin }));
            // setCopiedItem({ item, isMove })
        } else {
            localStorage.setItem("dragItem", JSON.stringify({ item, isMove }));
        }
    }, [actions]);

    // Equalize all actions state fields and inputs to items fields and inputs
    const findAndUpdateItem = useCallback((id, items) => {
        items.forEach(item => {
            if (item.id === id) {
                if (actions[id]) {
                    item.fields = actions[id].fields
                    item.inputs = actions[id].inputs
                }
                return true;
            } else if (item.children) {
                if (findAndUpdateItem(id, item.children)) {
                    return true;
                }
            }
        })
        return false;
    }, [actions])

    const dragItemSetField = useCallback((item, isMove, copy) => {
        let dragItem;
        if (copy) dragItem = JSON.parse(localStorage.getItem("copiedItem"));
        // if (copy) dragItem = copiedItem
        else dragItem = JSON.parse(localStorage.getItem("dragItem"));
        if (actions[dragItem?.item?.id]?.id) {
            item = {
                ...item,
                fields: actions[dragItem.item.id].fields
            }
        }


        return item;
    }, [actions])

    // In this method, debugStatus is reset.
    // Fields and inputs values of actions are populated from Actions.
    // Assigning label values for InitialActions.
    const updateFlowItems = (items, tmpActions) => {
        for (let item of items) {
            if (item.debugStatus) {
                item.debugStatus = '';
            }
            if (actions[item.id]) {
                item.fields = actions[item.id].fields
                item.inputs = actions[item.id].inputs
                if (item.label) {
                    tmpActions[item.id].label = item.label;
                }
                if (actions[item.id].eh_flow) {
                    let eh_flow = errorHandlingAutomDetails.find(x => x.errorHandlingId === item.id)
                    if (eh_flow && eh_flow.items) {
                        let eh_flow_items = JSON.parse(JSON.stringify(eh_flow.items))
                        let eh_flow_tab_name = JSON.parse(JSON.stringify(eh_flow.tabName))
                        let eh_flow_tab_color = JSON.parse(JSON.stringify(eh_flow.tabColor))
                        updateFlowItems(eh_flow_items, tmpActions)
                        item.eh_flow = { items: eh_flow_items, tabName: eh_flow_tab_name, tabColor: eh_flow_tab_color };
                    }
                }

                // if (!item.image_path && item.image && !item.image.includes('data:')) {
                //     const arr = item.image.split('/libraries');
                //     if (arr && arr.length === 2) {
                //         item.image_path = "/libraries" + arr[1]
                //         tmpActions[item.id].image_path = item.image_path;
                //     }
                // }
            }
            if (item.children) {
                updateFlowItems(item.children, tmpActions)
            }
        }
    }

    const preparePayloadData = async (type = "null", opId = "") => {
        let items = JSON.parse(JSON.stringify(automDetail.items))
        //items = resetItemsDebug(items)
        // Object.keys(actions).forEach(actionId => {
        //  findAndUpdateItem(actionId, items)
        // })
        let tmpActions = JSON.parse(JSON.stringify(actions));
        updateFlowItems(items, tmpActions);

        setInitialActions(tmpActions);
        // if(type === 'save'){
        //     items = items.filter(x => x.name !== 'TRIGGER');
        // }
        changeOrder(items, 0);
        if (type === "save") {
            return {
                autom_id: paramsId,
                operationId: opId?.length > 0 ? opId : operationId,
                version_id: automVersion?.length ? automVersion : "",
                updatingFields: [{ field_name: "flow", field_value: items }, {
                    field_name: "diagram",
                    field_value: diagramData
                }] // , { field_name: "trigger", field_value: triggerConfig }
            };
        } else if (type === "run") {
            // running flow depending on automDetail.integration_type
            items.splice(0, 1);
            return {
                flowActions: {
                    id: paramsId,
                    autom_version_id: automDetail.versionId,
                    name: automDetail.name,
                    description: automDetail.description,
                    // integration_type: automDetail.integration_type,
                    integration_type: triggerDetail.integration_type,
                    mate_id: automDetail.mate_id,
                    actions: items,
                    operationId: opId?.length > 0 ? opId : operationId,
                    isDebugging: debuggingStart, // debugger,
                    debuggingDelay: debuggingDelay,
                    queue_enabled: automDetail.queue_enabled,
                    qpool_id: automDetail.qpool_id
                },
            };
        } else if (type === "debug") {
            items.splice(0, 1);
            // if (findDebugAction(items)) {
            //     await handleDebugArray(items)
            // }
            return {
                flowActions: {
                    id: paramsId,
                    autom_version_id: automDetail.versionId,
                    name: automDetail.name,
                    description: automDetail.description,
                    // integration_type: automDetail.integration_type,
                    integration_type: triggerDetail.integration_type,
                    mate_id: automDetail.mate_id,
                    actions: items,
                    operationId: opId?.length > 0 ? opId : operationId,
                    isDebugging: debuggingStart, // debugger
                    debuggingDelay,
                    debugActionItemId: debugActionItemId
                },
            };
        } else if (type === "publish") {
            return items;
        }

        return items;
    }

    const saveFlow = useCallback(async () => {
        setOpenSaveModal(true)
        let payloadData = await preparePayloadData("save");

        if (payloadData.updatingFields && payloadData.updatingFields.length && payloadData.updatingFields[0]?.field_value) {
            // check empty field
            const isNullControl = await valueController(payloadData.updatingFields[0].field_value, []);
            if (isNullControl.indexOf(false) !== -1) {
                setOpenSaveModal(false)
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                    severity: 'error'
                }))
            }
        }

        const response = await AutomService.updateAutom(
            payloadData,
            paramsId
        );
        if (response && response.status) {
            setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.AUTOMS.AUTOM-SAVED"), severity: 'success' }))
            getVariables(automDetail.versionId)
            setSaveAvailable(false);
            setSavedFlow(automDetail.flow);
            setChangeFields({});
            // setAutomDetail({
            //     ...automDetail, items: JSON.parse(JSON.stringify(payloadData.updatingFields[0].field_value))
            // });
            setOpenSaveModal(false)
        } else {
            if (response.message === "APP-CREDENTIAL-CANNOT-BE-EMPTY") {
                const elem = document.getElementById("flow-warning" + response.id);
                if (elem) elem.style = "visibility:visible";
            }
            setAlert(alert => ({
                ...alert,
                show: true,
                message: response && response.message && typeof response.message === "string" ? t("MESSAGES.AUTOMS." + response.message) : t("MESSAGES.AUTOMS.AUTOMS-ADDED-FAILED"),
                severity: 'error'
            }))
            setOpenSaveModal(false)
        }
    }, [paramsId, preparePayloadData])

    function findDebugAction(items) {
        for (let i = 0; i < items.length; i++) {
            if ('children' in items[i]) {
                if (findDebugAction(items[i].children)) {
                    return true;
                }
            }
            if (items[i].isDebugging) {
                return true
            }
        }
        return false;
    }

    const runFlow = useCallback(async () => {
        setClearDebugs([]);
        setOpenSaveModal(true)
        // data convert and sort
        let payloadData = await preparePayloadData(debuggingStart ? "debug" : "run");

        // check empty field
        const isNullControl = await valueController(payloadData.flowActions.actions, []);
        if (isNullControl.indexOf(false) !== -1) {
            setOpenSaveModal(false)
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }
        const { status, data, message } = await AutomService.generateOperation(
            paramsId,
            automDetail.mate_id,
            false, // debugging Start
        );
        if (status && data) {
            setOperationId(data.operationId);
            // resp : number of autom waiting
            const responseQueue = await QueueService.getQueueStatus();
            setOpenSaveModal(false)
            let queue = false; // queue = false because we want flow to start directly
            if (responseQueue?.data?.count > 0 && queue) {
                await saveFlow();
                //then open waiting queue modal
                setNumberQueue(responseQueue?.data?.count);
                setOpenWaitingQueueModal(true);
            } else {
                if (debuggingStart) {
                    setOpenDebugRunning(true);
                    resetDebugStatus();
                } else
                    setOpenRunningModal(true);

                //running flow now
                recoilActions.connection();


                // set operationId
                payloadData.flowActions.operationId = data.operationId;
                payloadData.flowActions.tab_id = tab_id;
                const response = debuggingStart
                    ? await AutomService.debuggingAutom(payloadData)
                    : await AutomService.runAutom(payloadData);
                setOpenDebugRunning(false);
                if (response?.status) {
                    // setFlowstatus :1 response success
                    setFlowStatus(1);
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.AUTOMS.AUTOM-RUN"),
                        severity: 'success'
                    }))
                } else {
                    // setFlowstatus :2 response fail
                    setFlowStatus(2);
                    if (response) {
                        if (response.message.includes("System Error:")) {
                            setErrorMessage(response.message);
                            //setErrorMessage(response.message.replace("System Error:", ""));
                        } else {
                            setErrorMessage(
                                t("FLOW-MESSAGES.LIBRARY." + response?.message)
                            );
                        }
                    } else {
                        setErrorMessage(
                            t("GENERAL.NETWORK-ERROR")
                        );
                    }
                }
            }
        } else {
            setOpenSaveModal(false)
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + message),
                severity: 'error'
            }))
        }
    }, [debuggingStart, AutomService.generateOperation, QueueService, AutomService, paramsId, automDetail.mate_id, preparePayloadData])

    function handleDebugIconShow(id, items) {
        return items.map(item => {
            return { ...item };
        }).map(item => {
            if (item.hasOwnProperty('children')) {
                item.children = handleDebugIconShow(id, item.children);
            }
            if (item.id === id) {
                item.isDebugging = !item.isDebugging;
            } else {
                item.isDebugging = false;
            }
            return item;
        });
    }

    const debugFlow = useCallback(() => {
        // clear debug datas when opening/closing debug console
        setClearDebugs([]);

        // clear isDebugging all actions
        const modifiedItems = handleDebugIconShow('ALL', automDetail.items);
        setAutomDetail({
            ...automDetail, items: modifiedItems
        });

        setDebuggingStart(old => !old)
        if (debuggingStart) resetDebugStatus();
    }, [automDetail.items, debuggingStart])

    const editFlow = useCallback(async () => {
        setOpenEdit(true);
    }, [])

    const publishFlow = useCallback(async () => {
        let dataControl = await preparePayloadData(" ");
        const isNullControl = await valueController(dataControl, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }
        let payloadData = await preparePayloadData("publish");
        if (payloadData.length < (automDetail.type === 'Action' ? 3 : 4)) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.PUBLISH.EMPTY-FLOW-ITEMS"),
                severity: 'info'
            }))
        } else if (license.data.action_limit < payloadData.length - 2) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.PUBLISH.ACTION-LIMIT-EXCEEDED") + license.data.action_limit,
                severity: 'info'
            }))
        } else if (automDetail.type === 'Action' && variables.findIndex(x => x.type === 'app connector') === -1) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.PUBLISH.APP-CONNECTOR-NOT-FOUND"),
                severity: 'info'
            }))
            setOpenVariable(true);
        } else {
            setOpenPublish(true);
            setPublishFlowData(payloadData);
        }
    }, [automDetail.type, variables, license])

    const getVariables = useCallback((autom_version_id) => {
        VariableService.getVariable(autom_version_id).then((response) => {
            setVariables(response.data);
        });
    }, [])

    useEffect(() => {
        localStorage.removeItem("dragItem")
        async function getAutomDetail() {
            setIsMSTeamsExist(false);
            setIsWhatsappExist(false);
            setLoader(true);
            const response = await AutomService.getAutomsById(paramsId);
            if (response?.code && response.code === 404) {
                history('/my-environment/automs');
                return;
            }

            let dItem = JSON.parse(JSON.stringify(defaultItems));
            if (response.data.type === 'Autom') {
                // trigger unshift in default automDetail
                dItem.unshift(JSON.parse(JSON.stringify(defaultTriggerItem)));
            }
            handleInit(response.data?.flow?.length > 1 ? response.data?.flow : dItem);
            if (response?.data?.diagram?.length > 0) {
                setIsDiagramData(response.data.diagram)
            }

            if (response?.data?.trigger_type) {
                const type = response?.data?.trigger_type
                const integrationType = response?.data?.integration_type
                setTriggerSelection(response?.data?.trigger_type.split(','));
                setTriggerDetail({ trigger_type: type, integration_type: integrationType })
            } else {
                setTriggerSelection([]);
            }

            if (response?.data?.application_credential_id && response?.data.trigger_mode_id && response?.data?.trigger_setup) {
                setTriggerConf(conf => ({
                    ...conf,
                    app: {
                        id: response?.data?.application_id,
                        name: response?.data?.application_name,
                        image_path: response?.data?.image_path,
                        connector_fields: response?.data?.connector_fields
                    },
                    trigger: {
                        id: response?.data?.trigger_mode_id,
                        trigger_action_id: response?.data?.trigger_action_id,
                        name: response?.data?.trigger_action_name,
                        type: response?.data?.trigger_action_type
                    },
                    connector: { id: response?.data?.application_credential_id, name: response?.data?.credential_name },
                    setup: response?.data?.trigger_setup
                }))
            } else if (response?.data.trigger_mode_id) {
                setTriggerConf(conf => ({
                    ...conf,
                    app: {
                        id: response?.data?.application_id,
                        name: response?.data?.application_name,
                        image_path: response?.data?.image_path,
                        connector_fields: response?.data?.connector_fields
                    },
                    trigger: {
                        id: response?.data?.trigger_mode_id,
                        trigger_action_id: response?.data?.trigger_action_id,
                        name: response?.data?.trigger_action_name,
                        type: response?.data?.trigger_action_type
                    },
                    connector: {},
                    setup: {
                        fields: {},
                        conditions: [],
                        inputs: {}
                    }
                }))
            } else {
                setTriggerConf({
                    app: {},
                    trigger: {},
                    connector: {},
                    setup: {
                        fields: {},
                        conditions: [],
                        inputs: {}
                    }
                });
                setFieldPreviewData({
                    triggerData: {
                        data: {
                            field_path: {},
                            ff_name_path: {},
                        },
                        inputs: {},
                        inputConfigurations: []
                    }
                });
            }
            // Set actions state with all items on startup
            if (response.data?.flow && response.data.flow.length) {
                let newActions = {};
                let newInitialAction = {};
                setActionsForInitial(response.data.flow, newActions, newInitialAction);
                setActions(newActions);
                setInitialActions(newInitialAction);
            }

            setAutomVersion(response.data.versionId);
            // setAutomDetail({
            //     ...automDetail, ...response.data, activeItem: [],
            //     items: response.data?.flow?.length > 1 ? response.data?.flow : dItem
            // });
            setAutomDetail({
                ...automDetail, ...response.data,
                items: response.data?.flow?.length > 1 ? response.data?.flow : dItem
            });

            // every time autom is opened activeItem being default
            setActiveItems([])

            // Store the initial flow structure to saved flow state.
            setSavedFlow(response.data?.flow);


            getVariables(response.data.versionId);
            // Control is provided after autom details are get.
            await checkIsRunning(response.data);
            //if (response.data.is_installed) {
            setSaveAvailable(true);
            // }
            // const flow = document.getElementById('new-flow-drop-area-grid');
            // flow.style.left = `calc(50% - ${flow.offsetWidth / 2}px)`;
            setLoader(false);
        }
        if (isEhFlow || detailTabs) {
            setIsEhFLow(false)
            setDetailTabs([])
        }
        getAutomDetail();
        setItemExpand({})
        setDebugActionItemId('');
    }, [paramsId]);

    useEffect(() => {
        if (actions[selectedEhAutomDetail.errorHandlingId] && actions[selectedEhAutomDetail.errorHandlingId].eh_flow) {
            // const items = JSON.parse(JSON.stringify(selectedEhAutomDetail.items))
            const selectedEhFlow = JSON.parse(JSON.stringify(selectedEhAutomDetail))
            // actions[selectedEhAutomDetail.errorHandlingId].eh_flow.items = items
            actions[selectedEhAutomDetail.errorHandlingId].eh_flow = { items: selectedEhFlow.items, tabName: selectedEhFlow.tabName, tabColor: selectedEhFlow.tabColor }
            const newEhAutom = errorHandlingAutomDetails.map((autom) => {
                if (autom.errorHandlingId === selectedEhAutomDetail.errorHandlingId) {
                    return selectedEhAutomDetail
                }
                return autom
            })
            setErrorHandlingAutomDetails(newEhAutom)
        }
    }, [selectedEhAutomDetail])

    // Collect all items for setting actions state
    const setActionsForInitial = (items, newActions, newInitialAction) => {
        items.forEach((item) => {
            if (item.libraryName === "MICROSOFT-TEAMS") {
                setIsMSTeamsExist(true);
            }
            if (item.libraryName === "WHATSAPP") {
                setIsWhatsappExist(true);
            }
            if (item.id && item.fields) {
                newActions[item.id] = JSON.parse(JSON.stringify(item));
                newInitialAction[item.id] = JSON.parse(JSON.stringify(item));
            }
            if (item.children && item.children.length) {
                setActionsForInitial(item.children, newActions, newInitialAction)
            }
        })
    }

    useEffect(() => {
        // Check automid because old autom details are coming from recoil
        if (paramsId === automDetail?.id && automVersion === automDetail.versionId) {
            let item;
            // if (automDetail.activeItem.length) {
            //     item = JSON.parse(JSON.stringify(automDetail.activeItem[0]));
            // }
            if (activeItems.length) {
                item = JSON.parse(JSON.stringify(activeItems[0]));
            }
            // Deleting its activeted displaying class so that it can show to the activeItem element
            const oldActiveActionsEl = document.querySelectorAll(`.border-active-action`);
            for (const el of oldActiveActionsEl) {
                el.classList.remove("border-active-action")
            }
            // Adding active displaying class for activeItem element
            if (item && activeItems.length) {
                const _id = item.item_id ? item.item_id : item.id;
                const flow = document.querySelector(item.actionName === "START" ? `#start-container-border` : `#new-flow-drop-area-grid #act_${_id} > div`);
                if (flow) {
                    flow.classList.add("border-active-action")
                }
            }

            if (item && item.fields && !actions[item.id]) {
                if (item.libraryName === "WHATSAPP") {
                    setIsWhatsappExist(true);
                }
                if (item.libraryName === "MICROSOFT-TEAMS") {
                    setIsMSTeamsExist(true);
                }
                let id = JSON.parse(JSON.stringify(item.id))
                let label = item?.library_label?.includes('CUSTOM') ? item?.action_name : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
                setActions(prev => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        fields: JSON.parse(JSON.stringify(item.fields)),
                        actionName: JSON.parse(JSON.stringify(item.actionName)),
                        libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                        application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                        isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                        autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                        libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                        id,
                        item_id: item.item_id,
                        image: item?.image,
                        image_path: item?.image_path ? item.image_path : '',
                        actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                        inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null,
                        label
                    }
                }))

                setInitialActions(prev => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        fields: JSON.parse(JSON.stringify(item.fields)),
                        actionName: JSON.parse(JSON.stringify(item.actionName)),
                        libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                        application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                        isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                        autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                        libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                        id,
                        item_id: item.item_id,
                        image: item?.image,
                        image_path: item?.image_path ? item.image_path : '',
                        actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                        inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null,
                        label
                    }
                }))
            }
            // if (automDetail?.activeItem[0]?.name) {
            //     setShowRightArea(automDetail?.activeItem[0]?.name !== "START");
            // }
            if (activeItems[0]?.name) {
                setShowRightArea(activeItems[0]?.name !== "START");
            }
        }
        // }, [automDetail?.activeItem])
    }, [activeItems])

    useEffect(() => {
        // Check automid because old autom details are coming from recoil
        if (paramsId === automDetail?.id) {
            const tabIsFind = detailTabs.find((tab) => tab.id === tabFilter)
            if (!tabIsFind?.errorHandling) {
                let items = JSON.parse(JSON.stringify(automDetail.items))
                if (tabFilter === 0) {
                    findHidden('visible', items, false);
                } else {
                    if (tabIsFind) {
                        let focusedId = tabIsFind?.id; // items.filter(item => item.type !== 'standard')[tabFilter - 1].id;
                        if (focusedId) {
                            focusedId = focusedId.replace("custom_", "")
                        }
                        findHidden(focusedId || 'visible', items, true);
                    }
                }
                setIsEhFLow(false)
                setAutomDetail({ ...automDetail, items })
            }
            else {
                setIsEhFLow(true)
                const errorHandlingId = tabIsFind?.id
                const selectAutom = errorHandlingAutomDetails.find((autom) => autom.errorHandlingId === errorHandlingId)
                if (selectAutom) {
                    setSelectedEhAutomDetail(selectAutom)
                    handleInit(selectAutom.items, "errorHistory", errorHandlingId)
                }
            }
        }
    }, [tabFilter, automDetail?.id])

    useEffect(() => {
        // Check automid because old autom details are coming from recoil
        if (paramsId === automDetail?.id) {
            checkIsRunning(triggerDetail).then(r => r);
        }
    }, [reCheck])
    useEffect(() => {
        setShowRightArea(false)
    }, [isEhFlow])
    useEffect(() => {
        if (!isEhFlow) {
            const items = Object.values(actions)
            items.forEach((item) => {
                if (item.fields?.errorFlow?.value) {
                    const errorHandlingIcon = document.getElementById(`error-icon-${item.id}`)
                    if (errorHandlingIcon) {
                        errorHandlingIcon.style.display = "flex"
                    }
                }
                else if (item.fields?.errorFlow && !item.fields?.errorFlow?.value) {
                    const errorHandlingIcon = document.getElementById(`error-icon-${item.id}`)
                    if (errorHandlingIcon) {
                        errorHandlingIcon.style.display = "none"
                    }
                }
            })
        }
    }, [actions, isEhFlow])
    useEffect(() => {
        const dashedLineStyleCalculator = () => {
            const parent = document.querySelectorAll('.option-condition');
            parent.forEach((optionConditionElement) => {
                const optionContainerElement = optionConditionElement.querySelectorAll('.condition-container');
                if (optionContainerElement.length > 0) {
                    optionContainerElement.forEach(conditionElement => {
                        const nextElement = conditionElement.nextSibling
                        if (nextElement?.classList.value.includes("dashed-connect") && conditionElement?.classList.value.includes("dashed-connect")) {
                            const dashedLine = conditionElement.querySelector(`.dashed-connect-line`)
                            const parentElement = dashedLine.parentElement
                            const parentElementWidth = parentElement.offsetWidth
                            const nextElementWidth = nextElement.offsetWidth
                            if (parentElementWidth === 0 || nextElementWidth === 0) {
                                return
                            }
                            dashedLine.classList.remove("d-n")
                            dashedLine.style.left = parentElementWidth / 2 + "px"
                            dashedLine.style.width = (parentElementWidth / 2) + 60 + (nextElementWidth - (60)) / 2 + "px"
                        }
                        else {
                            const dashedLine = conditionElement.querySelector(`.dashed-connect-line`)
                            if (dashedLine) {
                                dashedLine.classList.add("d-n")
                            }
                        }
                    })
                }
            });
        }
        const horizontalLineStyleCalculator = () => {
            const iconWidth = 60;
            const staticAdditionalWidth = 8;
            const staticAdditionalLeft = 5;
            const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
            Array.prototype.forEach.call(conditionHoverLines, function (el) {
                // Do stuff here
                const sEl = findAncestor(el, "horizontal-condition-row");
                const leftPosition = (sEl.offsetWidth / 2) + (iconWidth / 2) + staticAdditionalLeft;
                const actualWidth = (sEl.offsetWidth - leftPosition) + staticAdditionalWidth;
                el.style.width = actualWidth + "px";
                el.style.left = leftPosition + "px";
            });
        }
        if (isDiagramBuilder) {
            const intervalId = setInterval(() => {
                const parent = document.querySelectorAll('.option-condition');
                if (parent && parent.length) {
                    dashedLineStyleCalculator()
                    clearInterval(intervalId)
                }
            }, 200);
            const intervalLine = setInterval(() => {
                const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
                if (conditionHoverLines && conditionHoverLines.length) {
                    horizontalLineStyleCalculator()
                    clearInterval(intervalLine)
                }
            }, 200);
            setTimeout(() => {
                clearInterval(intervalLine)
                clearInterval(intervalId)
            }, 2000);
        }
    }, [automDetail.items, isDiagramBuilder, errorHandlingAutomDetails, isEhFlow, showRightArea, showLeftArea, selectedEhAutomDetail, expand])


    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    const findHidden = (id, items, hiddenParent) => {
        for (const item of items) {
            if ((item.children && item.children?.length) || item.action_name === 'IF' || item.action_name === 'ELSEIF' || item.action_name === 'ELSE') {
                if (id !== 'visible' && item.id !== id && hiddenParent) {
                    item.hiddenParent = true;
                    if (hiddenParent) {
                        item.tabParent = true;
                    }
                    else {
                        item.tabParent = false;
                    }
                    if (item.children) findHidden(id, item.children, true);
                } else {
                    item.hiddenParent = false;
                    if (hiddenParent) {
                        item.tabParent = true;
                    }
                    else {
                        item.tabParent = false;
                    }
                    if (item.children) findHidden(id, item.children, false);
                }
            } else if (id !== 'visible' && item.id !== id && hiddenParent) {
                item.hidden = true;
            } else {
                if (hiddenParent) {
                    item.tabParent = true;
                }
                else {
                    item.tabParent = false;
                }
                item.hidden = false;
            }
        }
    }

    // check autom type and if trigger (email,schedule) update setTrigger state
    const checkIsRunning = async (autom) => {
        let type;
        if (autom?.trigger_action_type === 'schedule') {
            type = "APP-SCHEDULE";
        } else if (autom?.trigger_type && autom?.trigger_type.includes('webhook') && autom?.trigger_type.includes('app')) {
            type = "APP-TRIGGER"
        } else if (autom?.trigger_type && autom?.trigger_type.includes('email')) {
            type = "EMAIL";
        } else if (autom?.integration_type === "SCHEDULE") {
            type = "SCHEDULE"
        }
        if (type) {
            const response = await triggerService.checkIsRunningStatus(paramsId, type);
            if (response.code === 200) {
                setIsRunning(response.data.is_running);
            } else {
                setIsRunning(false);
            }

            setTrigger(true);
            setTriggerType(type);
        } else {
            setTrigger(false);
        }
    }

    //A new variable will be created when a new trigger flow added.
    const automaticallyVariableCreation = useCallback(async (triggerType) => {
        const response = await VariableService.getVariable(automVersion);

        //if integration type is a trigger and We search the
        //variable data, if the name is "trigger Param" we return true otherwise false
        if (triggerType?.split(",")?.includes("webhook") || triggerType?.split(",")?.includes("api")) {
            let filterParam = response?.data?.some((item) => (item.name === "triggerParam"));
            let filterHeader = response?.data?.some((item) => (item.name === "triggerHeader"));
            let filterQuery = response?.data?.some((item) => (item.name === "triggerQuery"));
            if (!filterParam) {
                const data = {
                    name: "triggerParam",
                    type: "object",
                    type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
                    description: "",
                    is_input: 0,
                    is_output: 0,
                    is_customizable: 0,
                    autom_version_id: automVersion,
                };
                const { status } = await VariableService.postVariable(data);
                if (status) {
                    setVariables(old => [...old, data])
                }
            }
            if (!filterHeader) {
                const dataHeader = {
                    name: "triggerHeader",
                    type: "object",
                    type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
                    description: "",
                    is_input: 0,
                    is_output: 0,
                    is_customizable: 0,
                    autom_version_id: automVersion,
                };
                const { status } = await VariableService.postVariable(dataHeader);
                if (status) {
                    setVariables(old => [...old, dataHeader])
                }
            }
            if (!filterQuery) {
                const dataQuery = {
                    name: "triggerQuery",
                    type: "object",
                    type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
                    description: "",
                    is_input: 0,
                    is_output: 0,
                    is_customizable: 0,
                    autom_version_id: automVersion,
                };
                const { status } = await VariableService.postVariable(dataQuery);
                if (status) {
                    setVariables(old => [...old, dataQuery])
                }
            }
        }
    }, [automVersion])

    const automaticallyWhatsappVariableCreation = useCallback(async (itemId, actionLabel) => {
        let variableType = "string"
        let variableTypeId = "c9057e86-cf7c-4256-8829-3608f447f86c"
        if (actionLabel === "SEND-CARD" || actionLabel === "SENDCARD" || actionLabel === "DYNAMICLIST") {
            variableType = "object"
            variableTypeId = "f1ff5b71-cf84-402b-b73c-eb4e399790b9"
        }

        const data = {
            name: `${actionLabel.toLowerCase().replaceAll('-', '')}_${itemId.replaceAll('-', '')}`,
            type: variableType,
            type_id: variableTypeId,
            description: "",
            is_input: 0,
            is_output: 0,
            is_customizable: 0,
            autom_version_id: automVersion,
            related_item_id: itemId
        };
        const { status } = await VariableService.postVariable(data);
        if (status) {
            setVariables(old => [...old, data])
            getVariables(automDetail.versionId)
        }
    }, [automVersion, automDetail?.versionId])

    const handleStart = useCallback(async (isTest) => {
        if (isTest) {
            setOpenTestAppLog(true);
            setTestAppStarted(true);
        }
        let dataControl = await preparePayloadData(" ");
        const isNullControl = await valueController(dataControl, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }

        const response = await triggerService.triggerStart({
            autom_id: paramsId,
            type: triggerType,
            it: isTest
        });
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: response?.status ? 'success' : 'error'
            }))
            if (response?.status) {
                //success
                // await saveFlow();
                setIsRunning(true);
            } else if (response.message === 'EXPIRE-EMAIL-REFRESH-TOKEN' && response.app_credential_id) {
                setGmailCredentialId(response.app_credential_id);
                setCredentialQuestion(true);
            }
        }
    }, [paramsId, triggerType, triggerService]);

    const handleStop = useCallback(async () => {
        const response = await triggerService.triggerStop({
            autom_id: paramsId,
            type: triggerType,
        });
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: response?.status ? 'success' : 'error'
            }))
            if (response?.status) {
                setIsRunning(false);
                setOpenDebugRunning(false);
            }
        }
    }, [triggerService, paramsId, triggerType]);

    const handleTestAppCancel = useCallback(async (isTest) => {
        let dataControl = await preparePayloadData(" ");
        const isNullControl = await valueController(dataControl, []);
        if (isNullControl.indexOf(false) !== -1) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("ACTIVE-DIRECTORY.NOT-NULL"),
                severity: 'error'
            }))
        }

        const response = await triggerService.triggerStop({
            autom_id: paramsId,
            type: triggerType
        });
        if (response) {
            if (response?.status) {
                const lMessage = isTest ? t("MESSAGES.AUTOMS.TEST-APP-PROCESS-COMPLETED") : t("MESSAGES.AUTOMS.TEST-APP-PROCESS-CANCELED")
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: lMessage,
                    severity: "success"
                }))
                //success
                if (!isTest) {
                    setOpenTestAppLog(false);
                }
                setTestAppStarted(false);
                setIsRunning(false);
            }
        }
    }, [paramsId, triggerType]);

    const handleDiagramBuilder = useCallback(() => {
        setShowRightArea(false);
        setIsDiagramBuilder(old => !old)
    }, [])

    const handleRoi = useCallback(() => {
        setOpenRoi(old => !old);
    }, [])

    const exportFunc = async (ok) => {
        if (ok) {
            await downloadFile(exportData);
        } else setExportData([]);
    }

    const importFunc = async (file, check_it, isVersionsChecked) => {
        const response = await AutomService.importFlow(file ? file : tempImportFile, automDetail.versionId, automDetail.type, check_it, !isVersionsChecked && !tempImportFile);
        if (response) {
            let requiredLibraries
            if (!isVersionsChecked && response.required_libraries) {
                requiredLibraries = response.required_libraries;
                if (requiredLibraries && requiredLibraries?.length) {
                    setTempImportFile(file)
                    setDifferentLibraryVersions(requiredLibraries)
                    return
                }
            }
            if (response.message === 'IMPORTED-AUTOM-IS-EMPTY') {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("CONTENT.IMPORT-AUTOM." + response.message),
                    severity: 'error'
                }));
                return;
            } else if (response.message === 'IMPORT-WARNING') {
                setOpenImportInfo({ apps: response.apps, open: true, file: file ? file : tempImportFile });
                return;
            }
            let message = t('MESSAGES.AUTOMS.' + response.message)
            if (response.code === 409) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: message,
                    severity: 'error'
                }));
                return;
            }
            message = !response.status ? message + ` - Variable name : ${response.data?.name}` : message
            setAlert(alert => ({
                ...alert,
                show: true,
                message: message,
                severity: response.status ? 'success' : 'error'
            }));

            if (response.status) {
                handleInit(response.data?.flow?.length > 1 ? response.data?.flow : defaultItems);
                if (response?.data?.diagram?.length > 0) {
                    setIsDiagramData(response.data.diagram)
                }

                const tempAutomDetail = JSON.parse(JSON.stringify(automDetail));
                tempAutomDetail.flow = response.data.flow;
                // setAutomDetail({
                //     ...automDetail, ...tempAutomDetail, activeItem: [],
                //     items: response.data?.flow?.length > 1 ? response.data?.flow : defaultItems
                // });
                let tempItems = response.data?.flow?.length > 1 ? response.data?.flow : defaultItems;
                setAutomDetail({
                    ...automDetail, ...tempAutomDetail,
                    items: tempItems
                });
                setActiveItems([])
                setOpenImport(false);
                setTempImportFile(undefined)
                getVariables(automVersion);

                // start save automs
                setOpenSaveModal(true);
                const payloadData = {
                    autom_id: paramsId,
                    operationId: operationId,
                    version_id: automVersion?.length ? automVersion : "",
                    updatingFields: [{ field_name: "flow", field_value: tempItems }, {
                        field_name: "diagram",
                        field_value: diagramData
                    }]
                };

                const rsp = await AutomService.updateAutom(
                    payloadData,
                    paramsId
                );
                if (rsp && rsp.status) {
                    setSaveAvailable(false);
                    setSavedFlow(JSON.parse(JSON.stringify(tempItems)));
                    setChangeFields({});
                    let newActions = {};
                    let newInitialAction = {};
                    setActionsForInitial(JSON.parse(JSON.stringify(tempItems)), newActions, newInitialAction);
                    setActions(newActions);
                    setInitialActions(newInitialAction);
                    setShowRightArea(false);
                    setOpenSaveModal(false);
                } else {
                    if (rsp.message.includes("System Error: Connection used in action named")) {
                        const elem = document.getElementById("flow-warning" + rsp.id);
                        if (elem) elem.style = "visibility:visible";
                    }
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: rsp && rsp.message ? t("MESSAGES.AUTOMS." + rsp.message) : t("MESSAGES.AUTOMS.AUTOMS-ADDED-FAILED"),
                        severity: 'error'
                    }))
                    setOpenSaveModal(false)
                }
                // setAutomVersion(response.vId);
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
        }
    }

    const slowMotionFunc = async (ms) => {
        if (ms >= 1000) {
            setDebuggingDelay(ms);
            setOpenSlowMotion(false);
        }
    }

    const handleActions = useCallback((item) => {
        if (item && item.fields && !actions[item.id]) {
            let id = JSON.parse(JSON.stringify(item.id))
            let label = item?.library_label?.includes('CUSTOM') ? item?.action_name : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
            setActions(prev => ({
                ...prev,
                [id]: {
                    ...prev[id],
                    fields: JSON.parse(JSON.stringify(item.fields)),
                    actionName: JSON.parse(JSON.stringify(item.actionName)),
                    libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                    application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                    isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                    autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                    libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                    id,
                    item_id: item.item_id,
                    image: item?.image,
                    image_path: item?.image_path ? item.image_path : '',
                    actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                    inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null,
                    label
                }
            }))

            setInitialActions(prev => ({
                ...prev,
                [id]: {
                    ...prev[id],
                    fields: JSON.parse(JSON.stringify(item.fields)),
                    actionName: JSON.parse(JSON.stringify(item.actionName)),
                    libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                    application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                    isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                    autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                    libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                    id,
                    item_id: item.item_id,
                    image: item?.image,
                    image_path: item?.image_path ? item.image_path : '',
                    actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                    inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null,
                    label
                }
            }))
        }
    }, [actions])

    const downloadFile = async (data) => {
        const fileName = exportData.fileName;
        const json = JSON.stringify({ flow: data.flow, variables: data.variables });
        const blob = new Blob([json], { type: 'application/json' });
        const href = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = fileName + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const findAndSetDebugStatus = (items, itemId, status, message) => {
        for (const i in items) {
            if (items[i].item_id === itemId) {
                items[i].debugStatus = status

                if (status === "error") {
                    items[i].debugErrorMessage = message;
                }
                break;
            } else if (items[i].hasOwnProperty('children')) {
                items[i].children = findAndSetDebugStatus(items[i].children, itemId, status, message);
            }
        }
        return items;
    }

    const setDebugStatus = (itemId, status, message) => {
        const items = JSON.parse(JSON.stringify(automDetail.items))
        const modifiedItems = findAndSetDebugStatus(items, itemId, status, message)
        setAutomDetail({
            ...automDetail, items: modifiedItems
        });
    }

    function resetItemsDebug(items) {

        return items.map(item => {
            return { ...item };
        }).map(item => {
            item.debugStatus = '';
            if (item.hasOwnProperty('children')) {
                item.children = resetItemsDebug(item.children);
            }
            return item;
        });
    }

    const resetDebugStatus = () => {
        // clear isDebugging all actions
        const modifiedItems = resetItemsDebug(automDetail.items)
        setAutomDetail({
            ...automDetail, items: modifiedItems
        });
    }

    const handleErrorOpenClick = useCallback((debugErrorMessage) => {
        setOpenErrorDialog(true);
        setDebugErrorMessage(debugErrorMessage)
    }, []);

    const handleErrorCloseClick = useCallback(() => {
        setOpenErrorDialog(false);
    }, []);

    const openResetTriggerConfiguration = useCallback(() => {
        setOpenResetTrigger(true);
    }, [])

    const disableAction = useCallback(async () => {

    })

    const handleCollapseLeftArea = () => {
        setShowLeftArea(false)
    }
    const handleExpandLeftArea = () => {
        setShowLeftArea(true)
    }

    const handleDevMode = useCallback(() => {
        setDevMode((pre) => !pre)
    }, [])

    const resetWPSession = useCallback(async (action) => {
        const payload = {
            automId: automDetail.id,
            automVersionId: automDetail.versionId,
            libraryName: "WHATSAPP",
            actionName: "RESET",
            action_name: "RESET",
            action_label: "RESET",
            name: "RESET"
        }

        let response = await AutomService.runAction(payload);

        if (response) {
            if (response.status) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.WHATSAPP.SESSION-RESET-SUCCESS"),
                    severity: response.status ? 'success' : 'error'
                }))
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.WHATSAPP.SESSION-RESET-FAILED"),
                    severity: 'error'
                }))
            }
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }))
        }
    }, [automDetail?.id, automDetail?.versionId, AutomService])

    const resetTriggerConfiguration = async () => {
        setTriggerConf({
            app: {},
            trigger: {},
            connector: {},
            setup: {
                fields: {},
                conditions: [],
                inputs: {}
            }
        });
        setFieldPreviewData({
            triggerData: {
                data: {
                    field_path: {},
                    ff_name_path: {}
                },
                inputs: {},
                inputConfigurations: []
            }
        });
        const response = await automService.updateTrigger({
            version_id: automDetail.versionId,
            trigger_type: null,
            trigger_config: {
                trigger_mode_id: null,
                application_credential_id: null,
                trigger_setup: {}
            }
        }, automDetail.id);


        if (response && response.status) {
            setTriggerSelectionData([]);
            // setAutomDetail({
            //     ...automDetail,
            //     integration_type: "STANDARD",
            //     trigger_type: null
            // });

            // The "triggerParam" variable may have been deleted. Therefore, the variables are re-fetched.
            getVariables(automDetail.versionId);
            setTriggerDetail({
                ...automDetail,
                integration_type: "STANDARD",
                trigger_type: null
            })
            setReCheck(!reCheck);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.TRIGGER.CONFIGURATION-RESET-SUCCESS"),
                severity: response.status ? 'success' : 'error'
            }))
        }
    }

    const updateVariableByItemId = useCallback(async (item_id, label) => {
        const i = variables.findIndex(x => x.related_item_id === item_id);
        if (i !== -1) {
            const newData = {
                updatingFields: [
                    {
                        field_name: "display_name",
                        field_value: label,
                    }
                ]
            }
            const result = await VariableService.updateVariable(newData, variables[i].id);
            if (result && result.status) {
                let copyVariables = JSON.parse(JSON.stringify(variables));
                copyVariables[i].display_name = label;
                setVariables(copyVariables);
            }
        }
    }, [variables])

    const handleTrigger = useCallback((type, integrationType) => {
        setTriggerDetail({ trigger_type: type, integration_type: integrationType })
    }, [])

    const setActiveItem = useCallback((e, item, config, type = 'normal') => {
        if (type === 'debug') {
            let items = JSON.parse(JSON.stringify(automDetail.items));
            let active = JSON.parse(JSON.stringify(item));
            let modifiedItems = handleDebugIconShow(item.id, items);
            // setAutomDetail({
            //     ...automDetail, items: modifiedItems, activeItem: [{
            //         ...active,
            //         actionName: active.action_name,
            //         libraryName: active.library_name,
            //         libraryLabel: active.library_label,
            //         isDebugging: !active.isDebugging,
            //     }]
            // });
            if (debugActionItemId === item.item_id) {
                setDebugActionItemId('');
            } else {
                setDebugActionItemId(item.item_id);
            }

            setAutomDetail({
                ...automDetail, items: modifiedItems
            });
            setActiveItems([{
                ...active,
                actionName: active.action_name,
                libraryName: active.library_name,
                libraryLabel: active.library_label,
                isDebugging: !active.isDebugging,
            }])
        } else {
            let activeItem, exist, selected = {
                ...item,
                actionName: item.action_name,
                libraryName: item.library_name,
                libraryLabel: item.library_label,
            };

            if (e.ctrlKey) {
                // activeItem = automDetail.activeItem.filter(i => {
                //     if (i.id === item.id) {
                //         exist = true;
                //         return false;
                //     } else return true;
                // });
                activeItem = activeItems.filter(i => {
                    if (i.id === item.id) {
                        exist = true;
                        return false;
                    } else return true;
                });
                if (!exist) activeItem.push(selected);
            } else activeItem = [selected];
            if (!(activeItem?.length > 0)) setShowRightArea(false);
            setActiveItems(activeItem)
            let copyActions
            setActions((action) => {
                copyActions = JSON.parse(JSON.stringify(action))
                return action
            })
            const actionIntervl = setInterval(() => {
                if (copyActions) {
                    clearInterval(actionIntervl)
                    if (copyActions && copyActions[selected.id] && copyActions[selected.id].eh_flow && copyActions[selected.id].fields?.errorFlow?.value) {
                        let copyTabs
                        setDetailTabs((tab) => {
                            copyTabs = tab
                            return tab
                        })
                        const detailTabInterval = setInterval(() => {
                            if (copyTabs) {
                                clearInterval(detailTabInterval)
                                let isOk = copyTabs.find((tab) => tab.id === copyActions[selected.id].id)
                                if (!isOk) {
                                    setErrorHandlingAutomDetails((pre) => [...pre, { ...automDetail, items: copyActions[selected.id].eh_flow.items, errorHandlingId: copyActions[selected.id].id, tabColor: copyActions[selected.id].eh_flow.tabColor, tabName: copyActions[selected.id].eh_flow.tabName }])
                                    setDetailTabs(e => [...e, { name: copyActions[selected.id].eh_flow?.tabName, color: copyActions[selected.id].eh_flow?.tabColor, item: [], errorHandling: true, id: copyActions[selected.id].id }]);
                                }
                            }
                        }, 100);
                    }
                }
            }, 100);
            if (config === "INPUT-SELECT") {
                const _id = item.item_id ? item.item_id : item.id;
                const flow = document.querySelector(`#new-flow-drop-area-grid #act_${_id}`);
                // const flowContainer = document.getElementById('new-flow-drop-area-grid');
                if (flow) {
                    flow.scrollIntoView({
                        block: "center",
                        inline: "center",
                    });
                    flow.style.backgroundColor = "#80808025";
                    setTimeout(() => {
                        flow.style.backgroundColor = "";
                    }, 1000)
                }
            }
        }
    }, [automDetail.items]);

    const changeLabelField = useCallback((id, actionLabel) => {
        setActions((action) => {
            let copyActions = action
            let selectAction = action[id]
            selectAction.fields.label.value = actionLabel
            copyActions = { ...copyActions, selectAction }
            return copyActions
        })
    }, [])

    const calculateheigth = () => {
        let h = 15;
        if (isWhatsappExist) {
            h += 5;
        }
        if (isMSTeamsExist) {
            h += 5;
        }
        return `${h}%`;
    }

    const handleShowChangeLeftIcon = (id, showMore) => {
        const element = document.querySelector(`#${id}`)
        if (element) {
            element.style.display = showMore ? "inline" : "none"
        }
    }


    const handleOpenErrorHandlingAutom = useCallback((item) => {
        let selected = {
            ...item,
            actionName: item.action_name,
            libraryName: item.library_name,
            libraryLabel: item.library_label,
        };
        let copyActions
        setActions((action) => {
            copyActions = JSON.parse(JSON.stringify(action))
            return action
        })
        const actionIntervl = setInterval(() => {
            if (copyActions) {
                clearInterval(actionIntervl)
                if (copyActions && copyActions[selected.id] && copyActions[selected.id].eh_flow && copyActions[selected.id].fields?.errorFlow?.value) {
                    let copyTabs
                    setDetailTabs((tab) => {
                        copyTabs = tab
                        return tab
                    })
                    const detailTabInterval = setInterval(() => {
                        if (copyTabs) {
                            clearInterval(detailTabInterval)
                            setSelectedEhAutomDetail({ ...automDetail, items: copyActions[selected.id].eh_flow.items, errorHandlingId: copyActions[selected.id].id, tabColor: copyActions[selected.id].eh_flow.tabColor, tabName: copyActions[selected.id].eh_flow.tabName })
                            handleInit(copyActions[selected.id].eh_flow.items, "errorHistory", item.id)
                            setErrorHandlingAutomDetails((pre) => [...pre, { ...automDetail, items: copyActions[selected.id].eh_flow.items, errorHandlingId: copyActions[selected.id].id, tabColor: copyActions[selected.id].eh_flow.tabColor, tabName: copyActions[selected.id].eh_flow.tabName }])
                            setTabFilter(copyActions[selected.id].id)
                            setIsEhFLow(true)
                            let isOk = copyTabs.find((tab) => tab.id === copyActions[selected.id].id)
                            if (!isOk) {
                                setDetailTabs(e => [...e, { name: copyActions[selected.id].eh_flow?.tabName, color: copyActions[selected.id].eh_flow?.tabColor, item: [], errorHandling: true, id: copyActions[selected.id].id }]);
                            }
                        }
                    }, 100);
                }
            }
        }, 100);
    }, [])

    return (

        !loader &&
        <div
            // 5.2 fr toplam
            style={{ gridTemplateColumns: `${showLeftArea ? "1.1fr" : "0.1fr"} ${showRightArea && showLeftArea ? "3fr" : showRightArea || showLeftArea ? "4.1fr" : "5fr"} ${showRightArea ? "1.1fr" : "0.1fr"}` }}
            className={`new-flow-container ${showTriggerRightArea ? "trigger" : ""} `}>
            <div className="new-flow-left">
                {showLeftArea ? <LeftArea
                    automType={automDetail.type}
                    handleDragStart={handleDragStart}
                    handleDragEnd={handleDragEnd}
                    isEhFlow={isEhFlow}
                    variables={variables}
                    setVariables={setVariables}
                    setOpenVariable={setOpenVariable}
                    openVariable={openVariable}
                    automVersionId={automVersion}
                    mateId={automDetail?.mate_id}
                /> : ""}
                <div className='left-icons-container' style={{ height: calculateheigth() }}>
                    <button onClick={handleRoi} className="diagram-flow-button roi-button" onMouseEnter={() => handleShowChangeLeftIcon("roi-calculator-text", true)}
                        onMouseLeave={() => handleShowChangeLeftIcon("roi-calculator-text", false)}>
                        <span id='roi-calculator-text' className='left-icons-text' >{t("CONTENT.FLOW.ROI-CALCULATOR")}</span>
                        <img src={RoiIcon} alt="" />
                    </button>
                    <button onClick={() => setOpenDrive(true)} className="diagram-flow-button" onMouseEnter={() => handleShowChangeLeftIcon("mate-drive-text", true)}
                        onMouseLeave={() => handleShowChangeLeftIcon("mate-drive-text", false)}>
                        <span id='mate-drive-text' className='left-icons-text'>{t("CONTENT.FLOW.MATE-DRIVE-TEXT")}</span>
                        <img src={DataStoreIcon} alt="" />
                    </button>
                    <button onClick={handleDiagramBuilder} className="diagram-flow-button" onMouseEnter={() => handleShowChangeLeftIcon("diagram-builder-text", true)}
                        onMouseLeave={() => handleShowChangeLeftIcon("diagram-builder-text", false)}>
                        <span id='diagram-builder-text' className='left-icons-text'>{t("CONTENT.FLOW.DIAGRAM-BUILDER")}</span>
                        <img src={DiagramIcon} alt="" />
                    </button>

                    {isMSTeamsExist && (
                        <Info value={t("CONTENT.FLOW.RESET-SESSION")} placement="right">
                            <button onClick={handleResetMSTeamsSession} className="diagram-flow-button">
                                <img src={MSTeamsIcon} alt="" />
                            </button>
                        </Info>
                    )}

                    {isWhatsappExist && (
                        <Info value={t("CONTENT.FLOW.RESET-SESSION")} placement="right">
                            <button onClick={resetWPSession} className="diagram-flow-button">
                                <img src={WhatsappIcon} alt="" />
                            </button>
                        </Info>
                    )}


                    {/* <Info value="Favorite Actions" placement="right">
                        <button onClick={handleDiagramBuilder} className="diagram-flow-button">
                            <img src={FavoriteActions} alt="" />
                        </button>
                    </Info> */}
                </div>
                <button onClick={() => showLeftArea ? handleCollapseLeftArea() : handleExpandLeftArea()} className="diagram-flow-button expand-collapse-left-area-button">
                    {showLeftArea ? <img src={CollapseLeftAreaIcon} alt="" /> : <img src={ExpandLeftAreaIcon} alt="" />}
                </button>
            </div>
            <div className="new-flow-middle">
                <MiddleArea
                    handleDragStart={handleDragStart}
                    automDetail={isEhFlow ? selectedEhAutomDetail : automDetail}
                    triggerDetail={triggerDetail}
                    setTriggerDetail={setTriggerDetail}
                    operationId={operationId}
                    setAutomDetail={!isEhFlow ? setAutomDetail : setSelectedEhAutomDetail}
                    isEhFlow={isEhFlow}
                    handleTrigger={handleTrigger}
                    resetFlow={resesFlowPopUp}
                    saveFlow={saveFlow}
                    runFlow={runFlow}
                    debugFlow={debugFlow}
                    editFlow={editFlow}
                    tabFilter={tabFilter}
                    setTabFilter={setTabFilter}
                    detailTabs={detailTabs}
                    setDetailTabs={setDetailTabs}
                    isFocused={!isEhFlow && tabFilter > 0}
                    setTriggerModal={setTriggerModal}
                    setOpenSchedule={setOpenSchedule}
                    trigger={trigger}
                    isRunning={isRunning}
                    triggerType={triggerType}
                    handleStart={handleStart}
                    handleStop={handleStop}
                    publishFlow={publishFlow}
                    setOpenDrive={setOpenDrive}
                    debuggingStart={debuggingStart}
                    setDebuggingExpand={setDebuggingExpand}
                    openRunningModal={openRunningModal}
                    setOpenDebugRunning={setOpenDebugRunning}
                    debuggingExpand={debuggingExpand}
                    handleRoi={handleRoi}
                    handleDiagramBuilder={handleDiagramBuilder}
                    findAndUpdateItem={dragItemSetField}
                    isDiagramBuilder={isDiagramBuilder}
                    diagramData={diagramData}
                    setIsDiagramBuilder={setIsDiagramBuilder}
                    setOpenRoi={setOpenRoi}
                    setDiagramData={setIsDiagramData}
                    setDialog={setDialog}
                    setShowRightArea={setShowRightArea}
                    setShowTriggerRightArea={setShowTriggerRightArea}
                    handleExport={handleExport}
                    handleImport={handleImport}
                    handleSlowMotion={handleSlowMotion}
                    setFlowStatus={setFlowStatus}
                    handleErrorOpenClick={handleErrorOpenClick}
                    handleErrorCloseClick={handleErrorCloseClick}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    // action={actions[automDetail.activeItem[0]?.id]}
                    // action={actions[activeItems[0]?.id]}
                    setReCheck={setReCheck}
                    reCheck={reCheck}
                    openResetTriggerConfiguration={openResetTriggerConfiguration}
                    testAppStarted={testAppStarted}
                    handleTestAppCancel={handleTestAppCancel}
                    automaticallyVariableCreation={automaticallyVariableCreation}
                    automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                    getVariables={getVariables}
                    updateVariableByItemId={updateVariableByItemId}
                    setActiveItem={setActiveItem}
                    savedFlow={savedFlow}
                    isDesktopRecorder={false}
                    handleActions={handleActions}
                    debugActionItemId={debugActionItemId}
                    changeLabelField={changeLabelField}
                    resetWPSession={resetWPSession}
                    setIsWhatsappExist={setIsWhatsappExist}
                    setIsMSTeamsExist={setIsMSTeamsExist}
                    setActions={setActions}
                    handleOpenErrorHandlingAutom={handleOpenErrorHandlingAutom}
                    handleDevMode={handleDevMode}
                    devMode={devMode}
                />
                {debuggingStart && (
                    <Debugger
                        setDebugStatus={setDebugStatus}
                        setDebuggingExpand={setDebuggingExpand}
                        showRightArea={showRightArea}
                        showTriggerRightArea={showTriggerRightArea}
                    />
                )}


                {/* {
                    showTriggerRightArea && (
                        <ConnectorField debugOpen={debuggingStart} debugExpand={debuggingExpand} />
                    )
                } */}
                {
                    !showRightArea &&
                    <div className="action-control-center-container">
                        <div className="field-preview-header-title">
                            <img src={actionControlIcon} alt="action control icon" />
                            <span className='margin-left-10'>
                                {t("CONTENT.FLOW.ACTION-CONTROL-CENTER")}
                            </span>
                            <img className='maximize-icon' src={maximizeIcon} onClick={() => setShowRightArea(true)} />
                        </div>
                    </div>
                }
            </div>

            {
                showRightArea &&
                <div className="new-flow-right">
                    <RightArea
                        setGroupLabel={setGroupLabel}
                        actions={actions}
                        // setSelected={setSelected}
                        // selectedAction={actions[automDetail.activeItem[0]?.id]}
                        selectedAction={actions[activeItems[0]?.id]}
                        //setSelected={setSelectedAction}
                        mateId={automDetail?.mate_id}
                        variables={variables}
                        setVariables={setVariables}
                        setOpenVariable={setOpenVariable}
                        //variableRender={variableRender}
                        automId={paramsId}
                        automVersionId={automVersion}
                        recorder={recorder}
                        //setRender={setRenderExt}
                        debuggingStart={debuggingStart}
                        debuggingExpand={debuggingExpand}
                        setDialog={setDialog}
                        setDetailTabs={setDetailTabs}
                        setTabFilter={setTabFilter}
                        isEhFlow={isEhFlow}
                        drecorder={drecorder}
                        setShowRightArea={setShowRightArea}
                        showTriggerRightArea={showTriggerRightArea}
                        setShowTriggerRightArea={setShowTriggerRightArea}
                        fromFlow={true}
                        automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                        setActiveItem={setActiveItem}
                        getVariables={getVariables}
                        // automDetail={automDetail}
                        automDetail={isEhFlow ? selectedEhAutomDetail : automDetail}
                        // setAutomDetail={setAutomDetail}
                        setAutomDetail={isEhFlow ? setSelectedEhAutomDetail : setAutomDetail}
                    />
                </div>
            }
            {openWaitingQueueModal && (
                <WaitingQueueModal
                    setOpen={setOpenWaitingQueueModal}
                    automDetail={automDetail}
                    numberQueue={numberQueue}
                />
            )}
            {openRunningModal && (
                <RunningModal
                    flowStatus={flowStatus}
                    hideTitle={true}
                    setOpen={setOpenRunningModal}
                    setFlowStatus={setFlowStatus}
                    errorMessage={errorMessage}
                    operationId={operationId}
                    mateId={automDetail.mate_id}
                />
            )}
            {openSaveModal && (
                <Dialog open={true} maxWidth={'sm'}><DialogActions style={{ padding: '30px' }}><CircularProgress /></DialogActions></Dialog >
            )}
            {openPublish && (
                <Publish
                    flow={publishFlowData}
                    variables={variables}
                    automDetail={automDetail}
                    setOpenPublish={setOpenPublish}
                />
            )}
            {openEdit && (
                <AddNewAutom
                    automDetail={automDetail}
                    setAutomDetail={setAutomDetail}
                    setOpenEdit={setOpenEdit}
                    setReCheck={setReCheck}
                    reCheck={reCheck}
                    automaticallyVariableCreation={automaticallyVariableCreation}
                />
            )}
            {openSchedule && (
                <Schedule
                    setOpen={setOpenSchedule}
                    automId={paramsId}
                    automDetail={automDetail}
                />
            )}
            {triggerModal && (
                <TriggerModal
                    setOpen={setTriggerModal}
                    setOpenVariable={setOpenVariable}
                    variables={variables}
                    automDetail={automDetail}
                    triggerDetail={triggerDetail}
                />
            )}
            {openDrive && (
                <MateDrive setOpen={setOpenDrive} flowId={paramsId} />
            )}
            {openRoi && <Roi setOpen={setOpenRoi} />}
            {openExport && (
                <ExportConfirm
                    setOpenExport={setOpenExport} message={t('CONTENT.FLOW.EXPORT-WARNING')} exportFunc={exportFunc}
                />
            )}
            {openImport && (
                <ImportModal
                    setOpenImport={setOpenImport} importFunc={importFunc} setTempImportFile={setTempImportFile}
                />
            )}
            {openSlowMotion && (
                <SlowMotionModal
                    setOpenSlowMotion={setOpenSlowMotion}
                    slowMotionFunc={slowMotionFunc}
                    timeout={debuggingDelay}
                />
            )}
            {openResetTrigger &&
                <DeleteConfirm setOpenDelete={setOpenResetTrigger}
                    message={t("CONTENT.FLOW.RESET-TRIGGER-CONFIRMATION")}
                    deleteFunc={resetTriggerConfiguration} />}
            {openResetFlow &&
                <DeleteConfirm setOpenDelete={setOpenResetFlow}
                    message={t("CONTENT.FLOW.RESET-FLOW-CONFIRMATION")}
                    deleteFunc={resetFlow}
                    okButtonLabel={t("CONTENT.FLOW.RESET-CONFIRM")} />}
            {openTestAppLog &&
                <TestAppLog setOpenTestAppLog={setOpenTestAppLog} showTriggerRightArea={showTriggerRightArea}
                    showRightArea={showRightArea} openRunningModal={openRunningModal}
                    handleTestAppCancel={handleTestAppCancel} />
            }
            {differentLibraryVersions &&
                <RequiredLibraries handleClose={() => setDifferentLibraryVersions(false)} callFunction={() => importFunc(undefined, true, true)}
                    data={{ required_libraries: differentLibraryVersions }} outLabel={"CONTENT.IMPORT-AUTOM.REQUIRED-LIBRARY."} handleCloseOutPanel={() => {
                        setOpenImport(false)
                        setTempImportFile(undefined)
                    }} />
            }
            {openDesktopRecord &&
                <DesktopActions
                    handleDragStart={handleDragStart}
                    handleDragEnd={handleDragEnd}
                    automDetail={isEhFlow ? selectedEhAutomDetail : automDetail}
                    triggerDetail={triggerDetail}
                    setTriggerDetail={setTriggerDetail}
                    actions={actions}
                    setGroupLabel={setGroupLabel}
                    paramsId={paramsId}
                    recorder={recorder}
                    drecorder={drecorder}
                    operationId={operationId}
                    setAutomDetail={isEhFlow ? setSelectedEhAutomDetail : setAutomDetail}
                    isEhFlow={isEhFlow}
                    handleTrigger={handleTrigger}
                    resetFlow={resesFlowPopUp}
                    saveFlow={saveFlow}
                    runFlow={runFlow}
                    debugFlow={debugFlow}
                    editFlow={editFlow}
                    tabFilter={tabFilter}
                    setTabFilter={setTabFilter}
                    detailTabs={detailTabs}
                    setDetailTabs={setDetailTabs}
                    setDialog={setDialog}
                    isFocused={!isEhFlow && tabFilter > 0}
                    setTriggerModal={setTriggerModal}
                    setOpenSchedule={setOpenSchedule}
                    trigger={trigger}
                    isRunning={isRunning}
                    triggerType={triggerType}
                    handleStart={handleStart}
                    handleStop={handleStop}
                    publishFlow={publishFlow}
                    setOpenDrive={setOpenDrive}
                    debuggingStart={debuggingStart}
                    setDebuggingExpand={setDebuggingExpand}
                    openRunningModal={openRunningModal}
                    setOpenDebugRunning={setOpenDebugRunning}
                    debuggingExpand={debuggingExpand}
                    handleRoi={handleRoi}
                    handleDiagramBuilder={handleDiagramBuilder}
                    findAndUpdateItem={dragItemSetField}
                    isDiagramBuilder={isDiagramBuilder}
                    diagramData={diagramData}
                    setIsDiagramBuilder={setIsDiagramBuilder}
                    setOpenRoi={setOpenRoi}
                    setDiagramData={setIsDiagramData}
                    setShowRightArea={setShowRightArea}
                    setShowTriggerRightArea={setShowTriggerRightArea}
                    handleExport={handleExport}
                    handleImport={handleImport}
                    handleSlowMotion={handleSlowMotion}
                    setFlowStatus={setFlowStatus}
                    handleErrorOpenClick={handleErrorOpenClick}
                    handleErrorCloseClick={handleErrorCloseClick}
                    variables={variables}
                    setVariables={setVariables}
                    openVariable={openVariable}
                    automType={automDetail.type}
                    automVersionId={automVersion}
                    setOpenVariable={setOpenVariable}
                    // action={actions[automDetail.activeItem[0]?.id]}
                    action={actions[activeItems[0]?.id]}
                    setReCheck={setReCheck}
                    reCheck={reCheck}
                    openResetTriggerConfiguration={openResetTriggerConfiguration}
                    testAppStarted={testAppStarted}
                    handleTestAppCancel={handleTestAppCancel}
                    setIsWhatsappExist={setIsWhatsappExist}
                    setIsMSTeamsExist={setIsMSTeamsExist}
                    automaticallyVariableCreation={automaticallyVariableCreation}
                    automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                    getVariables={getVariables}
                    updateVariableByItemId={updateVariableByItemId}
                    setActiveItem={setActiveItem}
                    automId={paramsId}
                    savedFlow={savedFlow}
                    setActions={setActions}
                />
            }
            {dialog && <TabDialog open={dialog} setOpen={setDialog} setDetailTabs={setDetailTabs} detailTabs={detailTabs} setErrorHandlingAutomDetails={setErrorHandlingAutomDetails} />}
            {credentialQuestion &&
                <DeleteConfirm setOpenDelete={setCredentialQuestion}
                    message={t("CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION.WOULD-YOU-LIKE-TO-BE-REDIRECT-OAUTH-LOGIN-PAGE")}
                    deleteFunc={() => setOpenAppCredential(true)} />}
            {openAppCredential && gmailCredentialId &&
                <AppCredentialModal appCredentialId={gmailCredentialId} selectedApp={gmailApp}
                    afterSave={afterSave} cancel={cancel} />}
            {openImportInfo && openImportInfo.open &&
                <DeleteConfirm setOpenDelete={() => setOpenImportInfo({ open: false })}
                    message={t("MESSAGES.AUTOMS.IMPORT-DEFAULT-APPS-INFO", { apps: openImportInfo.apps })}
                    deleteFunc={() => importFunc(openImportInfo.file, false)} />}
            <Dialog
                open={openErrorDialog}
                onClose={handleErrorCloseClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Error Detail"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ color: "rgb(215, 94, 94)" }}>
                        {t("FLOW-MESSAGES.LIBRARY." + debugErrorMessage)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleErrorCloseClick} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default NewFlow;
